import React, { memo } from "react";
import { Col, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { WitLabel } from "../styles";
import { defineMessages, FormattedMessage } from "react-intl";
import { UseFormReturn } from "react-hook-form";
import { InsuranceEntity } from "../entity";

const messages = defineMessages({
  restrictions: { id: "insurance.form.restrictions", defaultMessage: "Restrictions" },
  restrictionsMinStay: {
    id: "insurance.form.restrictionsMinStay",
    defaultMessage: "Minimum Stay (days)",
  },
  restrictionsMaxStay: {
    id: "insurance.form.restrictionsMaxStay",
    defaultMessage: "Maximum Stay (days)",
  },
  restrictionsMinNotice: {
    id: "insurance.form.restrictionsMinNotice",
    defaultMessage: "Minimum Notice (hours)",
  },
  restrictionsMaxNotice: {
    id: "insurance.form.restrictionsMaxNotice",
    defaultMessage: "Maximum Notice (hours)",
  },
});

export const RestrictionComponent = memo((props: UseFormReturn<InsuranceEntity>) => (
  <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <WitLabel>
        <FormattedMessage {...messages.restrictions} />
      </WitLabel>
    </FormLabel>
    <FormLabel column sm={12}>
      <FormattedMessage {...messages.restrictionsMinStay} />
    </FormLabel>
    <Col sm={2}>
      <FormControl type="number" {...props.register("restrictions.minStay")} min={0} />
    </Col>

    <FormLabel column sm={12}>
      <FormattedMessage {...messages.restrictionsMaxStay} />
    </FormLabel>
    <Col sm={2}>
      <FormControl type="number" {...props.register("restrictions.maxStay")} min={0} />
    </Col>

    <FormLabel column sm={12}>
      <FormattedMessage {...messages.restrictionsMinNotice} />
    </FormLabel>
    <Col sm={2}>
      <FormControl type="number" {...props.register("restrictions.minNotice")} min={0} />
    </Col>

    <FormLabel column sm={12}>
      <FormattedMessage {...messages.restrictionsMaxNotice} />
    </FormLabel>
    <Col sm={2}>
      <FormControl type="number" {...props.register("restrictions.maxNotice")} min={0} />
    </Col>
  </FormGroup>
));
